import { useQuery } from "@apollo/client";

import { parseDateToString } from "~/modules/app/util/dateHelpers";

import { PlannerV2FieldworkerGetFitForVisitDocument } from "../queries.generated";

export default function usePlannerV2FieldworkerGetVisitDetails({
    plannerVisitId,
    fieldworkerId,
    userId,
    availabilityStartAt,
    availabilityEndAt,
}: {
    plannerVisitId: string;
    fieldworkerId?: string;
    userId?: string;
    availabilityStartAt: Date;
    availabilityEndAt: Date;
}) {
    const { data, loading, error } = useQuery(PlannerV2FieldworkerGetFitForVisitDocument, {
        variables: {
            plannerVisitId,
            fieldworkerId: fieldworkerId ?? "",
            userId: userId ?? "",
            availabilityStartAt: parseDateToString(availabilityStartAt),
            availabilityEndAt: parseDateToString(availabilityEndAt),
        },
        skip: !fieldworkerId || !userId,
        errorPolicy: "all",
    });

    return {
        loading,
        error,
        data: {
            travelDistance: data?.plannerV2FieldworkerGetTravelDistanceFromVisit,
            availabilityByDate: data?.fieldworkerGetCalendarDaysEvents,
        },
    };
}
